module.exports = __webpack_public_path__ + "img/approche.bea6f8b9.png";